"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _antd = require("antd");

var _useGetPolygonGeomInteraction = _interopRequireDefault(require("../../../../hooks/interactions/useGetPolygonGeomInteraction"));

var _useWFSGetFeature = _interopRequireDefault(require("../../../../hooks/wfs/useWFSGetFeature"));

var _filter = require("ol/format/filter");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["url", "map", "vectorLayer", "wfsOptions", "fetchOptions", "msg"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * <p>
 *  Button to allow to retrieve the WFS features based on the Polygon 
 *  provided by the user.
 * </p>
 * 
 * <p>Remark: this component also is present in the <i>WfsFeatureGrid</i> component.</p>
 *
  * <p>
 *  Check in the <a href="https://ant.design/components/button/">documentation</a> 
 *  for additional properties for the button.
 * </p>
 * 
 * @visibleName WFS Search By Polygon Button
 */
var WfsSearchByPolygonButton = function WfsSearchByPolygonButton(_ref) {
  var url = _ref.url,
      map = _ref.map,
      vectorLayer = _ref.vectorLayer,
      wfsOptions = _ref.wfsOptions,
      fetchOptions = _ref.fetchOptions,
      msg = _ref.msg,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var geometryName = wfsOptions.geometryName;

  var _useGetPolygonGeomInt = (0, _useGetPolygonGeomInteraction.default)(map, msg),
      start = _useGetPolygonGeomInt.start,
      clear = _useGetPolygonGeomInt.clear,
      geometry = _useGetPolygonGeomInt.geometry,
      isRunning = _useGetPolygonGeomInt.isRunning;

  var wfsGetFeature = (0, _useWFSGetFeature.default)(); //retrieve the srs from map

  var proj = map.getView().getProjection();
  var srsName = proj.getCode();
  var axisOrientation = proj.getAxisOrientation();
  if (axisOrientation === 'neu') srsName = 'urn:x-ogc:def:crs:' + srsName;
  wfsOptions.srsName = srsName;
  var onClickHandler = (0, _react.useCallback)(function (event) {
    start();
  }, [start]);
  (0, _react.useEffect)(function () {
    if (geometry && !isRunning) {
      //clear layer
      vectorLayer.getSource().clear(); //create filter

      var geom = geometry;
      var filter = (0, _filter.intersects)(geometryName, geom, srsName);

      var wfsFilteredOptions = _objectSpread(_objectSpread({}, wfsOptions), {}, {
        filter: filter
      });

      wfsGetFeature.sendRequest(url, map, vectorLayer, wfsFilteredOptions, fetchOptions);
      clear();
    }
  }, [geometry, isRunning, vectorLayer, geometryName, srsName, map, url, wfsGetFeature, wfsOptions, fetchOptions, clear]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, _objectSpread(_objectSpread({}, otherProps), {}, {
    onClick: onClickHandler,
    disabled: isRunning,
    loading: wfsGetFeature.isLoading,
    children: otherProps.children
  }));
};

WfsSearchByPolygonButton.propTypes = {
  /**
   * The url used for the WFS request
   */
  url: _propTypes.default.string.isRequired,

  /**
   * The OpenLayers ol/Map where the WFS features will be rendered.
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * The <i>ol/layer/Vector</i> layer from where the WFS features will
   * be stored. 
   */
  vectorLayer: _propTypes.default.instanceOf(_Vector.default).isRequired,

  /**
   * The WFS options for the WFS GetFeature request.
   * This object has the same format as used in the OpenLayers 
   * <a href="https://openlayers.org/en/latest/apidoc/module-ol_format_WFS-WFS.html">
   * ol/format/WFS.writeGetFeature</a> method.
   */
  wfsOptions: _propTypes.default.object.isRequired,

  /**
   * Additional options to be used for the 
   * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch">fetch API</a>.
   */
  fetchOptions: _propTypes.default.object,

  /**
   * Message to be shown requesting the user to provide the Polygon.
   * If not provided, a default message will be provided by the application.
   */
  msg: _propTypes.default.string,

  /**
   * The child node for the button
   */
  children: _propTypes.default.node
};
var _default = WfsSearchByPolygonButton;
exports.default = _default;